import React, { useState } from 'react';
import { Button, Dropdown, Space, notification } from 'antd';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import useImportExportApi from 'hooks/useImportExportApi';
import { downloadFile } from 'utils/downloadFile';
import ImportWizard from './ImportWizard';

const ImportExportToolbar = ({
  scope,
  columns,
  config,
  humanName = 'registros',
  onCommitSuccess,
}) => {
  const api = useImportExportApi(config);
  const [importOpen, setImportOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleExport = async (format) => {
    setLoading(true);
    try {
      const blob = await api.exportData({ scope, format });
      let ref = null;
      if (scope.level === 'item') ref = `item-${scope.itemId}`;
      else if (scope.level === 'coleccion') ref = `coleccion-${scope.idColeccion}`;
      downloadFile(blob, ref ? `${humanName}-${ref}.${format}` : `${humanName}.${format}`);
    } catch (e) {
      notification.error({
        message: 'No se pudo exportar',
        description: e?.response?.data?.message || e.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Space>
      <Dropdown
        menu={{
          items: [
            { key: 'xlsx', label: 'Excel (.xlsx)', onClick: () => handleExport('xlsx') },
            { key: 'csv', label: 'CSV (;)', onClick: () => handleExport('csv') },
          ],
        }}
      >
        <Button icon={<DownloadOutlined />} loading={loading}>
          Exportar
        </Button>
      </Dropdown>
      <Button icon={<UploadOutlined />} onClick={() => setImportOpen(true)}>
        Importar {humanName}
      </Button>
      <ImportWizard
        open={importOpen}
        onClose={() => setImportOpen(false)}
        onSuccess={onCommitSuccess}
        scope={scope}
        columns={columns}
        config={config}
        humanName={humanName}
      />
    </Space>
  );
};

export default ImportExportToolbar;
